var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReference24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.3 11.7 20 4m0 0h-5.93M20 4v5.93M9.33 4.59H5.58C4.71 4.6 4 5.3 4 6.14v12.31c0 .86.7 1.55 1.58 1.55h12.25c.87 0 1.58-.7 1.58-1.55v-3.78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReference24);
export default __webpack_public_path__ + "static/media/reference_24.94f2cc65a5e5ae10d441e01729116d4e.svg";
export { ForwardRef as ReactComponent };